var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "municipalInfo", "data-role": "page" } }, [
    _c(
      "div",
      {
        staticClass: "municipalInfo-content",
        attrs: { "data-position": "fixed" }
      },
      [
        !_vm.closeOffline && _vm.isOffline
          ? _c("div", { staticClass: "v3offline" }, [
              _c("i", { staticClass: "icon-exclamation-mark-circle" }),
              _vm._v(" "),
              _c("p", [_vm._v("未連接至網路")]),
              _vm._v(" "),
              _c("div", { on: { click: _vm.closeOfflineHandle } }, [
                _c("i", { staticClass: "icon-close" })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swiper-container swiperTop",
            attrs: { id: "infoTop" }
          },
          [
            _c(
              "swiper",
              { ref: "infoTop", attrs: { options: _vm.swiperTop } },
              _vm._l(_vm.infoType, function(typeVal, typeIdx) {
                return _c(
                  "swiper-slide",
                  {
                    key: typeIdx,
                    staticClass: "swiper-slide",
                    attrs: { typeId: typeVal.typeId }
                  },
                  [_vm._v(_vm._s(typeVal.typeName))]
                )
              })
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swiper-container swiperPages",
            attrs: { id: "infoPages" }
          },
          [
            _c(
              "swiper",
              {
                ref: "infoPages",
                staticClass: "swiper-wrapper",
                attrs: { options: _vm.swiperPages }
              },
              _vm._l(_vm.infoType, function(typeVal, typeIdx) {
                return _c(
                  "swiper-slide",
                  {
                    key: typeIdx,
                    staticClass: "swiper-slide",
                    attrs: {
                      typeId: typeVal.typeId,
                      selected: typeVal.typeId === typeIdx + 1
                    }
                  },
                  [
                    _c(
                      "mescroll-vue",
                      {
                        ref: "mescroll",
                        refInFor: true,
                        attrs: {
                          down: _vm.getMescrollDown(typeIdx),
                          up: _vm.getMescrollUp(typeIdx)
                        },
                        on: {
                          init: function($event) {
                            _vm.mescrollInit(typeIdx, arguments)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "detailWrap" }, [
                          _c("div", { staticClass: "articleList" }, [
                            typeVal.typeList && typeVal.typeList.length
                              ? _c(
                                  "ul",
                                  [
                                    _vm._l(typeVal.typeList, function(
                                      infoVal,
                                      infoIdx
                                    ) {
                                      return [
                                        infoVal.CreateAt ||
                                        (infoVal.StartAt.indexOf("T") !== -1 &&
                                          new Date(
                                            infoVal.StartAt.split(
                                              "."
                                            )[0].replace("T", " ")
                                          ) < new Date())
                                          ? _c("li", { key: infoIdx }, [
                                              _c(
                                                "div",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.seeDetail(
                                                        typeVal.typeId,
                                                        infoVal.Id,
                                                        infoIdx
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "txt-info" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "article_desc"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              infoVal.Title
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "article_date"
                                                        },
                                                        [
                                                          infoVal.StartAt
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                " +
                                                                    _vm._s(
                                                                      _vm.filterDate(
                                                                        infoVal.StartAt,
                                                                        typeVal.typeId
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          infoVal.CreateAt
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                " +
                                                                    _vm._s(
                                                                      _vm.filterDate(
                                                                        infoVal.CreateAt,
                                                                        typeVal.typeId
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "cgy-tag"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                infoVal.ActivitiesClass
                                                                  ? infoVal.ActivitiesClass
                                                                  : infoVal.NewsClass
                                                              ) +
                                                              "\n                          "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "icon-chevron-right"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : !typeVal.typeList
                                ? _c("div", { staticClass: "empty" })
                                : !typeVal.typeList.length &&
                                  !typeVal.mescroll.isDownScrolling
                                  ? _c("div", { staticClass: "empty" }, [
                                      _c("div", { staticClass: "txt-box" }, [
                                        _c("i", {
                                          staticClass: "icon-system_empty"
                                        }),
                                        _vm._v(" "),
                                        _c("h4", [
                                          _vm._v("噢不！"),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(typeVal.typeName) +
                                              "尚未有任何訊息"
                                          )
                                        ])
                                      ])
                                    ])
                                  : _vm._e()
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              })
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.v3Toast.show,
            expression: "v3Toast.show"
          }
        ],
        staticClass: "v3Toast"
      },
      [_vm._v(_vm._s(_vm.v3Toast.text))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1599fa15", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1599fa15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v3/newMunicipal/municipalInfo.vue
// module id = null
// module chunks = 